import React, { useEffect } from 'react';

import UsersTable from '@components/UsersTable';

import { useAppDispatch } from '@store/store';

import { resetUsersTable, setOrganizationId } from '@slices/users';

import { TOrganizationType } from '@enums/common';

import { addTooltipText, searchTooltipText } from './constants';
import { searchPlaceholder } from '@components/routes/AdminPanel/UsersMainTableHOC/constants';

interface IUsersProfileTableHOCProps {
	id?: string;
	adminCount: number;
	organisationName?: string;
	organisationTypes: Array<TOrganizationType>;
}

const UsersProfileTableHOC = ({
	adminCount,
	id,
	organisationTypes,
	organisationName,
}: IUsersProfileTableHOCProps) => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (id) dispatch(setOrganizationId({ organizationId: id }));

		return () => {
			dispatch(resetUsersTable());
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	return (
		<UsersTable
			addTooltipText={addTooltipText}
			adminCount={adminCount}
			isCreatable
			organisationName={organisationName}
			organisationTypes={organisationTypes}
			searchPlaceholder={searchPlaceholder}
			searchTooltipText={searchTooltipText}
		/>
	);
};

export default UsersProfileTableHOC;
